module.exports = "/_next/static/images/d69d6a62a55b31589e16fb6262072a77-boy-looking-to-the-front@0.5x.jpg.webp";